import { render, staticRenderFns } from "./SemenQuarantinePositionChange.vue?vue&type=template&id=6c65c09b&scoped=true&"
import script from "./SemenQuarantinePositionChange.vue?vue&type=script&lang=js&"
export * from "./SemenQuarantinePositionChange.vue?vue&type=script&lang=js&"
import style0 from "./SemenQuarantinePositionChange.vue?vue&type=style&index=0&id=6c65c09b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65c09b",
  null
  
)

export default component.exports